module.exports = __webpack_public_path__ + "static/media/background.adbccee0.png";